unit uConstants;

interface

const
  JSON_SERVICE_URL        = 'https://promptlockers.com/mvp3/locker_data_service.php';

  LOCKER_STORAGE_API_BASE_URL  = 'https://promptlockers.com/mvp3/';

  LOCKER_STORAGE_API_KEY  = 'epaPTS5BnWpvRnKpdzMH';  // same for all (for now)
  LOCKER_PROMPTS_API_URL  = LOCKER_STORAGE_API_BASE_URL+'locker_prompts_api.php';
  LOCKER_METADATA_API_URL = LOCKER_STORAGE_API_BASE_URL+'locker_metadata_api.php';
  CATALOG_READER_URL      = LOCKER_STORAGE_API_BASE_URL+'catalog_reader.php';

  LOCKER_EXECUTE_API_URL = LOCKER_STORAGE_API_BASE_URL+'locker_execute_api.php';

  LOCKER_STATE_STORAGE_KEY = 'abracadabra';

  PROMPT_CONVERTER_LOCKER_ID = 'prompt-converter-001';


implementation

end.
